import { onMounted as t, onBeforeUnmount as r, openBlock as c, createElementBlock as n } from "vue";
import s from "./design-system.es142.js";
/* empty css                    */
import a from "./design-system.es128.js";
const p = {
  setup() {
    const { open: o, close: e } = s();
    t(() => {
      o();
    }), r(() => {
      e();
    });
  }
}, _ = { class: "overlay" };
function m(o, e, d, f, i, l) {
  return c(), n("div", _);
}
const x = /* @__PURE__ */ a(p, [["render", m], ["__scopeId", "data-v-c0a56a21"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es341.js.map
